import React from "react";
import { IOrderAddress } from "../../models/Order.model";

type InvoiceAddressFieldsProps = {
  billingAddress: IOrderAddress;
  shippingAddress: IOrderAddress;
  setBillingAddress: React.Dispatch<React.SetStateAction<IOrderAddress>>;
  setShippingAddress: React.Dispatch<React.SetStateAction<IOrderAddress>>;
};

const addressFields: (keyof IOrderAddress)[] = [
  "line1",
  "line2",
  "city",
  "state",
  "pincode",
];

const InvoiceAddressFields: React.FC<InvoiceAddressFieldsProps> = ({
  billingAddress,
  shippingAddress,
  setBillingAddress,
  setShippingAddress,
}) => {
  const renderAddress = (
    label: string,
    address: IOrderAddress,
    setAddress: React.Dispatch<React.SetStateAction<IOrderAddress>>,
  ) => (
    <fieldset className="grid grid-cols-1 gap-3 rounded-lg border border-slate-200 bg-slate-50/60 px-4 pb-4 pt-2 sm:grid-cols-2">
      <legend className="px-1 text-sm font-semibold text-slate-800">
        {label}
      </legend>
      {addressFields.map((field) => (
        <label
          key={`${label}-${field}`}
          className={`block text-xs font-medium text-slate-600 ${
            field === "line1" || field === "line2" ? "sm:col-span-2" : ""
          }`}
        >
          {field === "line1"
            ? "Address line 1"
            : field === "line2"
              ? "Address line 2"
              : field.toUpperCase()}
          <input
            type="text"
            value={address[field] || ""}
            onChange={(event) =>
              setAddress((current) => ({
                ...current,
                [field]: event.target.value,
                ...(field === "line2" ? { address: event.target.value } : {}),
              }))
            }
            className="mt-1.5 w-full rounded-md border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100"
          />
        </label>
      ))}
    </fieldset>
  );

  return (
    <div className="space-y-4">
      {renderAddress("Billing address", billingAddress, setBillingAddress)}
      {renderAddress("Shipping address", shippingAddress, setShippingAddress)}
    </div>
  );
};

export default InvoiceAddressFields;
